export const AUTOCOMPLETE_TYPING_DELAY_IN_MS = 300;

export const required = "is required";

export const emailPattern = {
  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  //value: /^\S+@\S+$/i,
  message: "Invalid email address",
};

export const emailValidation = {
  required,
  pattern: emailPattern,
};

export const phoneNumberValidation = {
  required,
  validate: {
    notEnoughDigits: (value) =>
      !value.match(/_/i) || "Please enter a valid phone number.",
  },
};

export const birthDateValidation = {
  required,
  validate: {
    validDate: (value) =>
      new Date(value) < new Date() || "Please enter a valid date.",
  },
};
